import {
  REACT_APP_ENV,
  REACT_APP_REGION,
  // REACT_APP_USERS_API,
  REACT_APP_aws_user_pools_id,
  REACT_APP_aws_user_pools_web_client_id,
  REACT_APP_aws_cognito_identity_pool_id,
  REACT_APP_aws_cognito_domain,
  REACT_APP_redirect_signin_uri,
  REACT_APP_redirect_signout_uri,
  // REACT_APP_GOOGLE_PLACES_KEY,
  REACT_APP_aws_region,
  REACT_APP_aws_appsync_region,
  REACT_APP_GRAPHQL_ENDPOINT,
  REACT_APP_WORKSPACE_COLLAB,
  REACT_APP_STRIPE_PK,
  REACT_APP_RTC_API,
  // REACT_APP_WORKSPACE_USERS,
  REACT_APP_REST_ENDPOINT,
  REACT_APP_SUPPORT_TOKEN,
  REACT_APP_AI_REST_ENDPOINT,
  REACT_APP_AIS_ENDPOINT,
  REACT_APP_SSO_TOKEN,
  REACT_APP_SUPPORT_WORKSPACE,
  REACT_APP_SUPPORT_AGENT,
  REACT_APP_REALTIME_ENDPOINT,
  REACT_APP_VOICE_SOCKET,
  REACT_APP_LIVEKIT_URL,
  REACT_APP_LIVEKIT_TOKEN_ENDPOINT,
  REACT_APP_LIVE_API_ENDPOINT,
  REACT_APP_SIP_DOMAIN,
  REACT_APP_LIVEKIT_INTERNAL_URL,
  REACT_APP_ANDROID_APP_ENABLED,
  REACT_APP_IOS_APP_ID,
} from "@env";

// Desktop (Electron): region config injected by preload.js (window.__TF_ENV__)
// before this module initializes. These values take precedence over the
// build-time values above so a single web build can serve every region — the
// user picks a region in the desktop app's first-run wizard and the matching
// values are injected at runtime. Web builds have no injection and use the
// build-time values unchanged.
const runtimeEnv =
  (typeof window !== "undefined" && window.__TF_ENV__) || {};

// Runtime value wins; missing/empty values fall back to the build-time value.
const withRuntime = (key, fallback) => {
  const value = runtimeEnv[key];
  return value === undefined || value === null || value === "" ? fallback : value;
};

export default {
  REACT_APP_ENV: withRuntime("REACT_APP_ENV", REACT_APP_ENV),
  // REACT_APP_USERS_API,
  REACT_APP_aws_user_pools_id: withRuntime(
    "REACT_APP_aws_user_pools_id",
    REACT_APP_aws_user_pools_id,
  ),
  REACT_APP_aws_user_pools_web_client_id: withRuntime(
    "REACT_APP_aws_user_pools_web_client_id",
    REACT_APP_aws_user_pools_web_client_id,
  ),
  REACT_APP_aws_cognito_identity_pool_id: withRuntime(
    "REACT_APP_aws_cognito_identity_pool_id",
    REACT_APP_aws_cognito_identity_pool_id,
  ),
  REACT_APP_aws_cognito_domain: withRuntime(
    "REACT_APP_aws_cognito_domain",
    REACT_APP_aws_cognito_domain,
  ),
  REACT_APP_redirect_signin_uri: withRuntime(
    "REACT_APP_redirect_signin_uri",
    REACT_APP_redirect_signin_uri,
  ),
  REACT_APP_redirect_signout_uri: withRuntime(
    "REACT_APP_redirect_signout_uri",
    REACT_APP_redirect_signout_uri,
  ),
  // REACT_APP_GOOGLE_PLACES_KEY,
  REACT_APP_aws_region: withRuntime("REACT_APP_aws_region", REACT_APP_aws_region),
  REACT_APP_aws_appsync_region: withRuntime(
    "REACT_APP_aws_appsync_region",
    REACT_APP_aws_appsync_region,
  ),
  REACT_APP_GRAPHQL_ENDPOINT: withRuntime(
    "REACT_APP_GRAPHQL_ENDPOINT",
    REACT_APP_GRAPHQL_ENDPOINT,
  ),
  REACT_APP_WORKSPACE_COLLAB: withRuntime(
    "REACT_APP_WORKSPACE_COLLAB",
    REACT_APP_WORKSPACE_COLLAB,
  ),
  REACT_APP_STRIPE_PK: withRuntime("REACT_APP_STRIPE_PK", REACT_APP_STRIPE_PK),
  REACT_APP_RTC_API: withRuntime("REACT_APP_RTC_API", REACT_APP_RTC_API),
  // REACT_APP_WORKSPACE_USERS,
  REACT_APP_REST_ENDPOINT: withRuntime(
    "REACT_APP_REST_ENDPOINT",
    REACT_APP_REST_ENDPOINT,
  ),
  REACT_APP_SUPPORT_TOKEN: withRuntime(
    "REACT_APP_SUPPORT_TOKEN",
    REACT_APP_SUPPORT_TOKEN,
  ),
  REACT_APP_AI_REST_ENDPOINT: withRuntime(
    "REACT_APP_AI_REST_ENDPOINT",
    REACT_APP_AI_REST_ENDPOINT,
  ),
  REACT_APP_AIS_ENDPOINT: withRuntime(
    "REACT_APP_AIS_ENDPOINT",
    REACT_APP_AIS_ENDPOINT,
  ),
  REACT_APP_SSO_TOKEN: withRuntime("REACT_APP_SSO_TOKEN", REACT_APP_SSO_TOKEN),
  REACT_APP_SUPPORT_WORKSPACE: withRuntime(
    "REACT_APP_SUPPORT_WORKSPACE",
    REACT_APP_SUPPORT_WORKSPACE,
  ),
  REACT_APP_SUPPORT_AGENT: withRuntime(
    "REACT_APP_SUPPORT_AGENT",
    REACT_APP_SUPPORT_AGENT,
  ),
  REACT_APP_REALTIME_ENDPOINT: withRuntime(
    "REACT_APP_REALTIME_ENDPOINT",
    REACT_APP_REALTIME_ENDPOINT,
  ),
  REACT_APP_REGION: withRuntime("REACT_APP_REGION", REACT_APP_REGION),
  REACT_APP_VOICE_SOCKET: withRuntime(
    "REACT_APP_VOICE_SOCKET",
    REACT_APP_VOICE_SOCKET,
  ),
  REACT_APP_LIVEKIT_URL: withRuntime(
    "REACT_APP_LIVEKIT_URL",
    REACT_APP_LIVEKIT_URL,
  ),
  REACT_APP_LIVEKIT_TOKEN_ENDPOINT: withRuntime(
    "REACT_APP_LIVEKIT_TOKEN_ENDPOINT",
    REACT_APP_LIVEKIT_TOKEN_ENDPOINT,
  ),
  REACT_APP_LIVE_API_ENDPOINT: withRuntime(
    "REACT_APP_LIVE_API_ENDPOINT",
    REACT_APP_LIVE_API_ENDPOINT,
  ),
  REACT_APP_SIP_DOMAIN: withRuntime("REACT_APP_SIP_DOMAIN", REACT_APP_SIP_DOMAIN),
  REACT_APP_LIVEKIT_INTERNAL_URL: withRuntime(
    "REACT_APP_LIVEKIT_INTERNAL_URL",
    REACT_APP_LIVEKIT_INTERNAL_URL,
  ),
  REACT_APP_ANDROID_APP_ENABLED: withRuntime(
    "REACT_APP_ANDROID_APP_ENABLED",
    REACT_APP_ANDROID_APP_ENABLED,
  ),
  REACT_APP_IOS_APP_ID: withRuntime("REACT_APP_IOS_APP_ID", REACT_APP_IOS_APP_ID),
};
